import { ScreenSizeType, useScreenSize } from '../../../hooks';
import styles from './practiceGrid.module.scss';
import { useMemo } from 'react';

const headerSize = new Map<ScreenSizeType, string>([
    [ScreenSizeType.xs, styles.headerSm],
    [ScreenSizeType.sm, styles.headerSm],
    [ScreenSizeType.md, styles.headerLg],
    [ScreenSizeType.lg, styles.headerXl],
    [ScreenSizeType.xl, styles.headerXl],
]);

const rowSize = new Map<ScreenSizeType, string>([
    [ScreenSizeType.xs, styles.rowSm],
    [ScreenSizeType.sm, styles.rowSm],
    [ScreenSizeType.md, styles.rowLg],
    [ScreenSizeType.lg, styles.rowXl],
    [ScreenSizeType.xl, styles.rowXl],
]);

export interface GridSize {
    isTabletView: boolean;
    headerHeight: number;
    rowHeight: number;
}

export function usePracticesGridSize(): GridSize {
    const { screenSize, isUpTo } = useScreenSize();
    return useMemo<GridSize>(() => {
        return {
            isTabletView: isUpTo(ScreenSizeType.lg),
            headerHeight: Number(headerSize.get(screenSize)),
            rowHeight: Number(rowSize.get(screenSize)),
        };
    }, [screenSize]);
}
